export default {
  title: 'Promocode',
  fields: {
    preset: {
      label: 'Voorinstelling',
    },
    presets: {
      master: 'Master',
      campaign: 'Campagne',
      one_time: 'Eenmalig',
    },
    code: {
      label: 'Code',
      placeholder: 'Code invoeren',
    },
    discount_type: {
      label: 'Kortingstype',
    },
    quantity: {
      label: 'Hoeveelheid',
      placeholder: 'Onbeperkt',
    },
    expires_at: {
      label: 'Vervaldatum',
      placeholder: 'Datum invoeren of leeg laten',
    },
    franchise: {
      label: 'Master-promotiecode voor het restaurant en/of het hele merk',
    },
    discount: {
      label: 'Korting',
    },
    usage_threshold: {
      label: 'Gebruiksdrempel',
    },
  },
  messages: {
    master_warning: 'Een nieuwe „master"-promocode aanmaken laat de huidige master-promocode verlopen',
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    promo_code_got_created: 'Promocode aangemaakt',
    promo_code_got_updated: 'Promocode bijgewerkt',
  },
};
